import React, { Fragment } from 'react';
import { getPublicImagePath, useAppState } from '@nutastic/nutastic-react-app';
import Gallery from '../Gallery';
import PageHeader from '../PageHeader';

const GalleryPage = () => {
    const { gallery = [] } = useAppState();

    return <Fragment>
        <PageHeader
            image={getPublicImagePath('gallery-head.jpg')}
            content="View the engagement photos of the bride and groom."
            iconClass="ion-ios-camera"
            subtitle="#ForveverJohnson"
            title="Gallery"
        />

        <section className="gallerySection">
            <Gallery images={gallery} />
        </section>

    </Fragment>;
};

export default GalleryPage;
